module.exports = "<div class=\"list-types flex-none\">\n\t<i class=\"material-icons\" ng-class=\"listType == 'box' ? 'active' : ''\" ng-click=\"setType('box')\">view_module</i>\n\t<i class=\"material-icons\" ng-class=\"listType == 'list' ? 'active' : ''\" ng-click=\"setType('list')\">list</i>\n\t<i class=\"material-icons\" ng-class=\"listType == 'table' ? 'active' : ''\" ng-click=\"setType('table')\">reorder</i>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/views/products-list-type.html
// module id = 368
// module chunks = 0